/**
 * Coloured pill that identifies a track's owner. Colour is derived from a
 * stable hash of the owner name so new owners get a reasonable default
 * palette without any config.
 */

interface Props {
  owner: string;
  className?: string;
}

const PALETTE = [
  "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-100",
  "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-100",
  "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-100",
  "bg-rose-100 text-rose-800 dark:bg-rose-900 dark:text-rose-100",
  "bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-100",
  "bg-teal-100 text-teal-800 dark:bg-teal-900 dark:text-teal-100",
  "bg-indigo-100 text-indigo-800 dark:bg-indigo-900 dark:text-indigo-100",
  "bg-pink-100 text-pink-800 dark:bg-pink-900 dark:text-pink-100",
];

function hash(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = (h << 5) - h + s.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}

export const OwnerBadge: React.FC<Props> = ({ owner, className = "" }) => {
  const color = PALETTE[hash(owner) % PALETTE.length];
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${color} ${className}`}
    >
      {owner}
    </span>
  );
};
